/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable radix */
import React from 'react';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';

import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { USER_FIELDS } from '../../hooks/use-user-form/userFormFields';

export default function FormUser({ onChange, formState, formError }) {
  const {
    NAME,
    LAST_NAME
  } = USER_FIELDS;

  return (
    <>
      <TextField
        id="outlined-basic"
        label="Nome *"
        variant="outlined"
        value={formState[NAME]}
        onChange={(e) => onChange(NAME, e.target.value)}
        error={!!formError[NAME]}
        helperText={formError[NAME]}
      />
      <TextField
        id="outlined-basic"
        label="Sobrenome *"
        variant="outlined"
        value={formState[LAST_NAME]}
        onChange={(e) => onChange(LAST_NAME, e.target.value)}
        error={!!formError[LAST_NAME]}
        helperText={formError[LAST_NAME]}
      />
    </>
  );
}

FormUser.propTypes = {
  onChange: PropTypes.func.isRequired,
  formState: PropTypes.objectOf(PropTypes.string).isRequired,
  formError: PropTypes.objectOf(PropTypes.string).isRequired,
};
